// import StampOrVirtualStampFormItem from '../../components/calculation-form/components/form-items/stamp-or-virtual-stamp-form-item'
import StampNumber from '../../../calculations/components/calculation-form/components/other/stamp-number'
import VirtualStampNumber from '../../../calculations/components/calculation-form/components/other/virtual-stamp-number'
import { onCellStandard } from '../../helpers/helpers'
// import {  VIRTUAL_STAMP_FIELD_DESCRIPTORS } from '../../helpers/helpers'
import type { DataSourceItem } from '../../shipments-page'
import { ShipmentColumn } from '../../types/column-types'

export const stampIdColumn: ShipmentColumn = {
    key: 'stampId',
    dataIndex: ['stamp', 'number'],
    // relationPath: ['stamp'],
    title: 'Штамп',
    width: 74,
    // editable: true,
    // FormItem: <StampOrVirtualStampFormItem />,
    render: (v: number, r: DataSourceItem) => {
        return r.withoutCutting ? <VirtualStampNumber data={r} /> : <StampNumber data={r} />
    },
    onCell: onCellStandard,
    // onCell: (record: DataSourceItem) => {
    //     if (isCalculation(record)) {
    //         return { colSpan: 0 }
    //     }
    //     return {
    //         colSpan: 1,
    //         dataIndex: record.withoutCutting ? ['virtualStamp'] : ['stamp'],
    //         ...(record.withoutCutting ? { fieldDescriptors: VIRTUAL_STAMP_FIELD_DESCRIPTORS } : {}),
    //     }
    // },
}
